import React, { useState } from "react";
import { Field } from "formik";

const PasswordField = ({ name, className = "form-control form-control-lg bg-light border-0", style = { fontSize: "1rem" } }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="input-group">
      <Field
        name={name}
        type={visible ? "text" : "password"}
        className={className}
        style={style}
      />
      <button
        type="button"
        className="btn bg-light border-0 px-3"
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        onClick={() => setVisible((current) => !current)}
      >
        <i className={`bi ${visible ? "bi-eye-slash" : "bi-eye"}`}></i>
      </button>
    </div>
  );
};

export default PasswordField;
